import { render } from "./Builder.vue?vue&type=template&id=12b15e7c&ts=true"
import script from "./Builder.vue?vue&type=script&lang=ts"
export * from "./Builder.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/homebrew/var/www/pickaso/pickaso-reporting-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__